"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var table_with_bulk_picker_builder_component_1 = require("./settings/table-with-bulk-picker-builder.component");
require("./table-with-bulk-picker.component.scss");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var Observable_1 = require("rxjs/Observable");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var type_configuration_service_1 = require("../../shared/services/api/type-configuration.service");
var Subject_1 = require("rxjs/Subject");
var table_with_bulk_picker_settings_component_1 = require("./settings/table-with-bulk-picker-settings.component");
var table_type_1 = require("./enums/table-type");
var static_method_1 = require("../../shared/utils/static-method");
var TableWithBulkPickerComponent = /** @class */ (function () {
    function TableWithBulkPickerComponent(typeConfigurationService) {
        this.typeConfigurationService = typeConfigurationService;
        this.subEntities = [];
        this.buttonConfigs = [];
        this.customTableActions = [];
        this.showTable = false;
        this.TableType = table_type_1.TableType;
        this.idPrefix = 'selenium-test-bulk-picker-';
        this._destroy$ = new Subject_1.Subject();
    }
    TableWithBulkPickerComponent.prototype.ngOnChanges = function (changes) {
        if (this.entity && !this.isPopupOpened) {
            this.showTable = !!this.subEntities.length;
        }
    };
    TableWithBulkPickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.configured) {
            this.tableLabel = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map(JSON.parse(this.label)));
            this.isRequired = this.form && this.form.metaForm.requiredMetaFieldIds.some(function (metaFieldId) { return metaFieldId.getSystemName() === _this.subEntityFieldId; });
            this.idPrefix += static_method_1.convertToKebabCase(this.subEntityFieldId);
            this.mainEntityCategoryName = this.mainEntityMetaField['compoundCategorySystemName'];
            this.mainEntityFieldName = this.mainEntityMetaField['metaFieldId']['systemName'];
            this.typeConfigurationService.getTypedCategoryProperties(this.mainEntityCategoryName)
                .takeUntil(this._destroy$)
                .subscribe(function (typeConfigs) {
                _this.mainEntityTypeConfigs = typeConfigs;
                if (_this.subEntities && _this.subEntities.length) {
                    _this.showTable = true;
                }
            });
        }
    };
    TableWithBulkPickerComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    TableWithBulkPickerComponent.prototype.setPopupState = function (isPopupOpened) {
        this.isPopupOpened = isPopupOpened;
        if (!isPopupOpened) {
            this.showTable = !!this.subEntities.length;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.EntityDefault)
    ], TableWithBulkPickerComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_dynamic_forms_ui_1.DynamicFormComponent)
    ], TableWithBulkPickerComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableWithBulkPickerComponent.prototype, "categoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableWithBulkPickerComponent.prototype, "subEntityCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableWithBulkPickerComponent.prototype, "subEntityFieldId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TableWithBulkPickerComponent.prototype, "subEntities", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_kb_service_client_js_1.MetaField)
    ], TableWithBulkPickerComponent.prototype, "mainEntityMetaField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], TableWithBulkPickerComponent.prototype, "tableType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], TableWithBulkPickerComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], TableWithBulkPickerComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], TableWithBulkPickerComponent.prototype, "actionNotifier", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableWithBulkPickerComponent.prototype, "label", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TableWithBulkPickerComponent.prototype, "colSystemNames", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TableWithBulkPickerComponent.prototype, "cellCounts", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TableWithBulkPickerComponent.prototype, "buttonConfigs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_kb_service_client_js_1.MetaField)
    ], TableWithBulkPickerComponent.prototype, "groupByMetaField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TableWithBulkPickerComponent.prototype, "customTableActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], TableWithBulkPickerComponent.prototype, "showDeleteButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], TableWithBulkPickerComponent.prototype, "editFormId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TableWithBulkPickerComponent.prototype, "mainEntityImageFieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], TableWithBulkPickerComponent.prototype, "configured", void 0);
    TableWithBulkPickerComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'ejustice-table-with-bulk-picker',
            template: require('./table-with-bulk-picker.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n        <ejustice-table-with-bulk-picker \n            [entity]=\"entity\"\n            [form]=\"form\"\n            [categoryId]=\"category\"\n            [subEntityCategoryId]=\"'%{field-category}'\"\n            [subEntityFieldId]=\"'%{field-name}'\"\n            [subEntities]=\"%{field}\"\n            [mainEntityMetaField]=\"%{mainEntityMetaField}\"\n            [tableType]=\"%{tableType}\"\n            [isReadonly]=\"%{isReadonly}\"\n            [currentLanguageId]=\"currentLanguageId\"\n            [actionNotifier]=\"actionNotifier\"\n\n            [label]=\"%{label}\"\n            [colSystemNames]=\"%{colSystemNames}\"\n            [cellCounts]=\"%{cellCounts}\"\n            [buttonConfigs]=\"%{buttonConfigs}\"\n\n            [groupByMetaField]=\"%{groupByMetaField}\"\n\n            [customTableActions]=\"%{customTableActions}\"\n            [showDeleteButton]=\"%{showDeleteButton}\"\n            [editFormId]=\"%{editFormId}\"\n\n            [mainEntityImageFieldName]=\"%{mainEntityImageFieldName}\"\n\n            [configured]=\"%{configured}\">\n        </ejustice-table-with-bulk-picker>\n    ",
            cellCount: 12,
            settings: {
                main: table_with_bulk_picker_settings_component_1.TableWithBulkPickerSettingsComponent,
                central: table_with_bulk_picker_builder_component_1.TableWithBulkPickerBuilderComponent,
            },
            groups: [{ identity: 'input', name: 'Input Elements' }],
            iconInfo: 'fa-dot-circle-o',
            name: 'Table with Bulk Picker',
        }),
        __metadata("design:paramtypes", [type_configuration_service_1.TypeConfigurationService])
    ], TableWithBulkPickerComponent);
    return TableWithBulkPickerComponent;
}());
exports.TableWithBulkPickerComponent = TableWithBulkPickerComponent;
//# sourceMappingURL=table-with-bulk-picker.component.js.map